// import React, { useEffect, useState } from 'react';
// import { Modal, Button } from 'antd';
// import { useNavigate } from 'react-router-dom'
// import { useMyContext } from '../../context/MyContext'
// import { toast } from 'react-toastify'
// import { doc, updateDoc } from 'firebase/firestore'
// import { db } from '../../config/firebase'
// import { api } from '../../config/api';
// import { Viewer } from '@toast-ui/react-editor';
// import { ImWarning } from 'react-icons/im';

// const IorTermsPopup = () => {
//     const navigate = useNavigate()
//     const [terms, setTerms] = useState({})
//     const [showTerms, setShowTerms] = useState(false)
//     const [isNew, setIsNew] = useState(false)
//     const { user, updateUserProfile } = useMyContext()

//     const handleAccept = async () => {
//         if (!user) return
//         try {
//             const userRef = doc(db, 'users', user.uid)

//             await updateDoc(userRef, {
//                 tradeOsTermsAccepted: true,
//                 tradeOsTermsVersion: terms.version
//             })

//             updateUserProfile({ tradeOsTermsAccepted: true, tradeOsTermsVersion: terms.version })
//             setShowTerms(false)
//             setIsNew(false)

//         } catch (error) {
//             toast.error("Error accepting TradeOS terms");
//             navigate('/')
//             console.error("Error accepting TradeOS terms:", error);
//         }
//     }

//     const handleReject = async () => {
//         if (!user) return
//         try {
//             const userRef = doc(db, 'users', user.uid)

//             await updateDoc(userRef, {
//                 tradeOsTermsAccepted: false
//             })

//             updateUserProfile({ tradeOsTermsAccepted: false })

//             setShowTerms(false)
//             toast.info('You must accept the TradeOS terms to use this tool.')
//             navigate('/')

//         } catch (error) {
//             toast.error("Error accepting TradeOS terms");
//             navigate('/')
//             console.error("Error accepting TradeOS terms:", error);
//         }

//     }

//     const getTerms = async () => {
//         try {
//             const res = await api.get('/terms-conditions?search=tradeos');
//             const { data } = res.data;
//             setTerms(data[0] || {});
//         } catch (error) {
//             console.error('Error getting TradeOS Terms', error);
//             toast.error('Error getting TradeOS Terms');

//         }
//     }

//     useEffect(() => {
//         if (!terms || Object.keys(terms).length === 0 || !user) return

//         if (
//             !user.tradeOsTermsAccepted ||
//             (user.tradeOsTermsVersion && user.tradeOsTermsVersion !== terms.version)
//         ) {
//             if (user.tradeOsTermsVersion !== terms.version) {
//                 setIsNew(true)
//             }
//             setShowTerms(true)
//         } else {
//             setIsNew(false)
//             setShowTerms(false)
//         }

//     }, [user, terms])

//     useEffect(() => {
//         getTerms()
//     }, [])

//     const renderTitle = () => {
//         return (
//             <div className="flex flex-col items-start justify-center">
//                 <h2 className="text-2xl font-semibold">
//                     {isNew ? `We've updated our TradeOS™ Terms and Conditions` : "TradeOS™ — Terms and Conditions"}
//                 </h2>
//                 {isNew && (
//                     <p className=" text-gray-600 mt-1">
//                         Please review and accept the updated terms and conditions
//                     </p>
//                 )}
//             </div>
//         )
//     }

//     return (
//         showTerms ?
//             <Modal
//                 title={renderTitle()}
//                 open={showTerms}
//                 onCancel={handleReject}
//                 footer={[
//                     <Button onClick={handleReject}>
//                         I Decline the Terms
//                     </Button>,
//                     <Button type="primary" onClick={handleAccept}>
//                         I Accept the Terms
//                     </Button>
//                 ]}
//                 centered
//                 width={900}
//             >
//                 <div className="py-2">

//                     <Viewer initialValue={terms?.content} />
//                 </div>
//             </Modal>
//             : null

//     );
// };

// export default IorTermsPopup;


import React, { useEffect, useState } from 'react';
import { Modal, Button, Spin } from 'antd';
import { Viewer } from '@toast-ui/react-editor';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { api } from '../../config/api';
import { useMyContext } from '../../context/MyContext';

const IorTermsPopup = () => {
    const navigate = useNavigate();
    const { user, updateUserProfile, welcomeTourActive } = useMyContext();

    const [terms, setTerms] = useState(null);       // null = loading
    const [showModal, setShowModal] = useState(false);
    const [isNew, setIsNew] = useState(false);

    // -------------------------------
    // Fetch the terms once
    // -------------------------------
    const loadTerms = async () => {
        try {
            const res = await api.get('/terms-conditions?search=tradeos');
            const { data } = res.data;

            if (!data || !data[0]) {
                toast.error("Unable to load TradeOS terms.");
                return;
            }

            setTerms(data[0]);
        } catch (err) {
            toast.error("Unable to load TradeOS terms.");
            console.error(err);
        }
    };

    useEffect(() => {
        loadTerms();
    }, []);

    // -------------------------------
    // Decide whether to show the modal
    // -------------------------------
    useEffect(() => {
        if (!terms || !user) return;  // Still loading something

        const hasAccepted = user.tradeOsTermsAccepted;
        const lastVersion = user.tradeOsTermsVersion;
        const currentVersion = terms.version;

        // Case 1: user never accepted
        if (!hasAccepted) {
            setShowModal(true);
            setIsNew(false);
        } else if (lastVersion !== currentVersion) {
            setShowModal(true);
            setIsNew(true);
        } else {
            setShowModal(false);
        }
    }, [terms, user]);

    // ──────────────────────────────
    // NOW safe to early return — all hooks already called
    // ──────────────────────────────
    if (welcomeTourActive) {
        return null;
    }

    // Accept handler
    const handleAccept = async () => {
        try {
            await updateDoc(doc(db, "users", user.uid), {
                tradeOsTermsAccepted: true,
                tradeOsTermsVersion: terms.version,
            });

            updateUserProfile({
                tradeOsTermsAccepted: true,
                tradeOsTermsVersion: terms.version,
            });

            setShowModal(false);
            setIsNew(false);
        } catch (err) {
            toast.error("Error accepting TradeOS terms");
            navigate('/');
            console.error(err);
        }
    };

    // -------------------------------
    // Reject handler
    // -------------------------------
    const handleReject = async () => {
        try {
            await updateDoc(doc(db, "users", user.uid), {
                tradeOsTermsAccepted: false
            });
            updateUserProfile({ tradeOsTermsAccepted: false });
        } catch {
            toast.error("Error updating terms status.");
        }

        toast.info("You must accept the TradeOS terms to continue.");
        navigate('/');
    };

    // -------------------------------
    // Render Logic
    // -------------------------------
    if (!terms) {
        return (
            <div className="w-full flex justify-center mt-10">
                <Spin tip="Loading Terms..." />
            </div>
        );
    }

    if (!showModal) return null;

    return (
        <Modal
            open
            centered
            width={900}
            closable={false}
            title={
                <div className="flex flex-col">
                    <h2 className="text-xl font-semibold">
                        {isNew
                            ? "We’ve Updated Our TradeOS™ Terms & Conditions"
                            : "TradeOS™ — Terms & Conditions"}
                    </h2>

                    {isNew && (
                        <p className="text-gray-500 mt-1">
                            Please review and accept the updated terms.
                        </p>
                    )}
                </div>
            }
            footer={[
                <Button onClick={handleReject}>I Decline</Button>,
                <Button type="primary" onClick={handleAccept}>I Accept</Button>,
            ]}
        >
            <Viewer initialValue={terms.content} />
        </Modal>
    );
};

export default IorTermsPopup;
